import React, { useEffect } from "react";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import OverviewCard from "../../../components/cards/OverviewCard";
import { Package } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchOrderSummaryAsync } from "../../../redux/features/orderSlice";

const OrderSummary = () => {
  const { loading, orderSummary } = useAppSelector((state) => state.orders);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchOrderSummaryAsync());
  }, [dispatch]);

  return (
    <WhiteTitledCard cardTitle="Overview">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <OverviewCard
          title="Total Order"
          value={orderSummary?.totalOrders ?? 0}
          icon={Package}
          iconBg="bg-bgRed"
          isLoading={loading}
          loadingColor="#CA2222"
        />
        <OverviewCard
          title="Successful Order"
          value={orderSummary?.successfulOrders ?? 0}
          icon={Package}
          change={orderSummary?.successRate.toFixed(2)}
          isPositive={Number(orderSummary?.successRate) > 0}
          iconBg="bg-bgBlue"
          isLoading={loading}
          loadingColor="#2C14DD"
        />
        <OverviewCard
          title="Pending Order"
          value={orderSummary?.pendingOrders ?? 0}
          icon={Package}
          change={orderSummary?.pendingRate.toFixed(2)}
          isPositive={Number(orderSummary?.pendingRate) > 0}
          iconBg="bg-bgPurple"
          isLoading={loading}
          loadingColor="#3F2EC8"
        />
        <OverviewCard
          title="Cancelled Order"
          value={orderSummary?.cancelledOrders ?? 0}
          icon={Package}
          change={orderSummary?.cancelRate.toFixed(2)}
          isPositive={Number(orderSummary?.cancelRate) > 0}
          iconBg="bg-bgBlack"
          isLoading={loading}
          loadingColor="#000"
        />
      </div>
    </WhiteTitledCard>
  );
};

export default OrderSummary;
